import {
  CURRENCY_CODES, DEFAULT_CURRENCY, isUnknownCurrency, unitLabel,
} from './currency';

/**
 * The clinic currencies a person can choose from, and what each one is called.
 *
 * The allow-list is the framework's (`CURRENCY_CODES`, IRR first) — the same closed
 * table the BFF and every service validate against (docs/clinic-currency/CONTRACTS.md
 * §1), so a picker built from it cannot offer a code the save would refuse.
 *
 * IRR is named from this app's catalogue, «ریال ایران — نمایش به تومان»: the
 * currency is the rial and the figures on screen are toman, and a picker that said
 * only «تومان» would read like a different currency. Every other code is its long
 * name from the currency table, in the reader's language.
 */
export function currencyName(code, t, locale) {
  return code === DEFAULT_CURRENCY ? t('clinic.currency.irrName') : unitLabel(code, locale, 'long');
}

/**
 * «US dollar (USD)» — how a currency is named in a picker or a read-only field.
 * A code this build does not know is shown as itself (lib/currency.js): there is
 * no name to give it, and inventing one would be a guess.
 */
export function currencyLabel(code, t, locale) {
  if (isUnknownCurrency(code)) return String(code);
  return t('clinic.currency.option', { name: currencyName(code, t, locale), code });
}

/**
 * `[{ value: 'IRR', label: 'ریال ایران — نمایش به تومان (IRR)' }, …]` for a kit
 * `Select`. `current`, when it is a code this build does not know, is offered
 * first as itself — otherwise the picker would show the first allowed currency
 * while the clinic is in another one.
 */
export function currencyOptions(t, locale, current) {
  const known = CURRENCY_CODES.map((code) => ({ value: code, label: currencyLabel(code, t, locale) }));
  return isUnknownCurrency(current) ? [{ value: current, label: String(current) }, ...known] : known;
}

export { DEFAULT_CURRENCY };
